<template>
  <plv-dialog
    v-model="dialogVisible"
    class="c-account-setting-dialog"
    width="580px"
    content-style="padding: 0 24px;"
    show-footer-btn
    append-to-body
    title="系统设置"
    @confirm="onConfirm"
  >
    <live-system-setting
      ref="liveSystemSetting"
      label="云直播设置"
    />
  </plv-dialog>
</template>

<script>
import LiveSystemSetting from '@/component/liveSystemSetting/liveSystemSetting.vue';

export default {
  name: 'AccountSettingDialog',
  components: {
    LiveSystemSetting,
  },
  data() {
    return {
      dialogVisible: false
    };
  },
  methods: {
    $open() {
      if (this.$refs.liveSystemSetting) {
        this.$refs.liveSystemSetting.$setSettings([]);
      }
      this.dialogVisible = true;
    },
    onConfirm() {
      let result = [];
      if (this.$refs.liveSystemSetting) {
        result = this.$refs.liveSystemSetting.$getSettings([]);
      }
      this.$emit('confirm', result);
      this.dialogVisible = false;
    },
  }
};
</script>

<style lang="scss">
.c-account-setting-dialog {
  .c-live-system-setting__title {
    font-size: 14px;
  }
}
</style>
